import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const exportStyledExcel = async (
  data,
  fileName,
  mainHeaderMessage,
  subHeaderMessage,
  afsoName 
) => {
  if (!data || data.length < 2) {
    console.error("Invalid data for Excel export");
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Report");

  const orangeFill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFA500" },
  };
  const blackText = { color: { argb: "FF000000" } };
  const blackBorder = { style: "thin", color: { argb: "FF000000" } };
  const allBorders = {
    top: blackBorder,
    left: blackBorder,
    bottom: blackBorder,
    right: blackBorder,
  };

  const numColumns = data[0].length + 1; 

  worksheet.mergeCells(1, 1, 1, numColumns);
  const headerCell = worksheet.getCell("A1");
  headerCell.value = mainHeaderMessage;
  headerCell.font = { bold: true, size: 14, ...blackText };
  headerCell.alignment = { vertical: "middle", horizontal: "center" };
  headerCell.fill = orangeFill;
  headerCell.border = allBorders;

  worksheet.mergeCells(2, 1, 2, numColumns);
  const subHeaderCell = worksheet.getCell("A2");
  subHeaderCell.value = afsoName
    ? `${subHeaderMessage} - AFSO: ${afsoName}`
    : subHeaderMessage;
  subHeaderCell.font = { bold: true, size: 12, ...blackText };
  subHeaderCell.alignment = { vertical: "middle", horizontal: "center" };
  subHeaderCell.fill = orangeFill;
  subHeaderCell.border = allBorders;

  const headerRow = worksheet.addRow(["SL No", ...data[0]]);
  headerRow.font = { bold: true, ...blackText };
  headerRow.fill = orangeFill;
  headerRow.alignment = { vertical: "middle", horizontal: "left" };
  headerRow.eachCell((cell) => {
    cell.border = allBorders;
  });

  const totalRowData = data[data.length - 1];
  const dataRows = data.slice(1, data.length - 1);

  dataRows.forEach((rowData, index) => {
    const row = worksheet.addRow([index + 1, ...rowData]);
    row.eachCell((cell) => {
      cell.border = allBorders;
      cell.alignment = { vertical: "middle", horizontal: "left" };
    });
  });

 const totalRow = worksheet.addRow(["Total", ...totalRowData]);
totalRow.eachCell((cell) => {
  cell.font = { bold: true, ...blackText };
  cell.fill = orangeFill;
  cell.border = allBorders;
  cell.alignment = { vertical: "middle", horizontal: "left" }; 
});

  const maxWidth = 30;
  worksheet.columns.forEach((col) => {
    let maxLength = 0;
    col.eachCell({ includeEmpty: true }, (cell) => {
      const value = cell.value ? cell.value.toString() : "";
      maxLength = Math.max(maxLength, value.length);
    });
    col.width = Math.min(Math.max(maxLength, 10), maxWidth);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), fileName);
};
